import {
  PalletDescriptionEditDto,
  PalletDescriptionWithOrder,
} from './../../scenes/orders/orders/pages/palletDescription/PalletDescriptions';
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { AxiosResponse } from 'axios';

import type { ResultDto } from 'svila-common';

import { API_URL } from '../../utils/constants';

import request from '../request';

export default {
  change: async (id: string, values: PalletDescriptionEditDto): Promise<AxiosResponse<ResultDto>> => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/pallet-descriptions/${id}`, 'put', body);
  },

  getPalleDescription: async (
    id: string,
    removed: boolean,
  ): Promise<AxiosResponse<PalletDescriptionWithOrder>> => {
    return request(`${API_URL}/pallet-descriptions/for-order/${id}/${removed}`, 'get');
  },
};
